module.exports = __webpack_public_path__ + "img/thumbnail-212574130.b417d869.jpeg";